import React, { useEffect, useRef, useCallback } from 'react';
import MainContent from '../../components/MainContent';
import PageContainer from '../../components/PageContainer';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ProfitAndLossCard from '../../components/Dashboard/Analytics/ProfitAndLossCard';
import ExpensesDonutCard from '../../components/Dashboard/Analytics/ExpensesDonutCard';
import FinancialPositionCard from '../../components/Dashboard/Analytics/FinancialPositionCard';
import InvoicesCard from '../../components/Dashboard/Analytics/InvoicesCard';
import RecentLedgerCard from '../../components/Dashboard/Analytics/RecentLedgerCard';
import ExpenseGraphs from '../../components/Dashboard/ExpenseGraphs';
import BalanceAccounts from '../../components/Dashboard/BalanceAccounts';
import ProjectsScroller from '../../components/Dashboard/Analytics/ProjectsScroller';
import { useLedger } from '../../DataStore/LedgerContext';
import { useStat } from '../../DataStore/StatContext';
import { useReport } from '../../DataStore/ReportContext';
import { useBalance } from '../../DataStore/BalanceContext';


export default function FinanceDashboard() {
  const {getRecentLedgers} = useLedger();
  const {getNetWorth, getTopExpenses, getProfitLoss} = useStat();
  const {getWeeklyIncomeGraph, getMonthlyIncomeGraph} = useReport();
  const { getCashBankListing, getCashBank } = useBalance();
  const isFetchingRef = useRef(false);
  const intervalRef = useRef(null);

  // Wrap all fetch logic in a single stable callback
  const fetchAll = useCallback(async () => {
    if (isFetchingRef.current) return; // prevent overlap
    if (document.hidden) return;       // pause when tab inactive

    try {
      isFetchingRef.current = true;

      await Promise.all([
        getRecentLedgers(true),
        getNetWorth(true),
        getTopExpenses(true),
        getProfitLoss(true),
        getWeeklyIncomeGraph(true),
        getMonthlyIncomeGraph(true),
        getCashBankListing(true),
        getCashBank(true),
      ]);

    } finally {
      isFetchingRef.current = false;
    }
  }, [
    getRecentLedgers,
    getNetWorth,
    getTopExpenses,
    getProfitLoss,
    getWeeklyIncomeGraph,
    getMonthlyIncomeGraph,
    getCashBankListing,
    getCashBank
  ]);

  useEffect(() => {
    // Run immediately
    fetchAll();

    // Run every 60 seconds
    intervalRef.current = setInterval(fetchAll, 60 * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Finance"
          description="Snapshot of your company financial position"
          showsCompany
          iconClass="fa fa-chart-line"
        />

        <div className="row">
          <div className="col-lg-8">
            <ProjectsScroller />
            <div className='row'>
                <div className="col-lg-6"><FinancialPositionCard /></div>
                <div className="col-lg-6"><ExpensesDonutCard /></div>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <ExpenseGraphs />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6"><BalanceAccounts /></div>
              <div className="col-lg-6"><InvoicesCard /></div>
            </div>

          </div>
          <div className="col-lg-4">
            <ProfitAndLossCard />
            <RecentLedgerCard />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
           
          </div>
        </div>
      </MainContent>
    </PageContainer>
  );
}
